import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setItemsPerPage } from '../../actions/pages'

// UI component for dropdown.
const ItemsDropdown = ({value,handleChange}) => (
    <select value={value} 
        className="form-control"
        onChange={handleChange}
    >
        <option value="5">Show 5 items</option>
        <option value="10">Show 10 items</option>
        <option value="25">Show 25 items</option>
        <option value="50">Show 50 items</option>
    </select>
)

// Actual class
class ShowItems extends Component{
    constructor(props){
        super(props)
        this.state = {
            input1: '10'
        }
        this.handleItemsDropdown = this.handleItemsDropdown.bind(this)
    }

    handleItemsDropdown(event){
        this.setState({
            input1: event.target.value
        })
    }

    componentDidUpdate(){
        this.bindToState()
    }

    bindToState(){
        this.props.dispatch(setItemsPerPage(
            this.props.id,
            Number(this.state.input1)
        ))
    }

    render(){
        let i1 = this.props.value1
        return(
            <div className="form-group">               
                <ItemsDropdown
                    value={i1}
                    handleChange={this.handleItemsDropdown}
                />               
            </div>
        )
    }
}

export default connect()(ShowItems)


// WEBPACK FOOTER //
// ./src/components/filters/showItems.js